import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Search from "../assets/images/search.png";
import Axios from "axios";
import heading from "../assets/images/heading.png";
import "../App.css";
import back from "../assets/images/back_arrow.png";
import { useNavigate } from "react-router-dom";
import user from "../assets/images/user.png";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import $ from "jquery";
import { message } from "antd";
import Header from "../components/Header";
export default () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [buttonHide, setButtonHide] = useState(false);
  const [msg, setMsg] = useState("");
  const [addDoctorDialog, setAddDoctorDialog] = useState(false);
  const [specialization, setSpecialization] = useState("");
  const [specializationDetails, setSpecializationDetails] = useState([]);
  const [doctorsName, setDoctorsName] = useState("");
  const [locationAddress, setLocationAddress] = useState("");
  const [doctorList, setDoctorList] = useState([]);
  const location = useLocation();
  let pid = localStorage.getItem("patientid");
  // console.log(location.state);
  const navigate = useNavigate();

  const phoneNumberChangeHandler = (e) => {
    setPhoneNumber(e.target.value);
  };
  const specializationHandeler = (e) => {
    setSpecialization(e.target.value);
  };
  const locationChangeHandler = (e) => {
    setLocationAddress(e.target.value);
  };
  const nameChangeHandler = (e) => {
    setDoctorsName(e.target.value);
  };

  const logoutHandler = () => {
    localStorage.removeItem("phoneNo");
    localStorage.removeItem("patientid");
    localStorage.removeItem("patientLocalImage");
    localStorage.removeItem("patientLocalData");
    localStorage.removeItem("patientUniqueId");
    localStorage.removeItem("chronic_illness_data");
    localStorage.removeItem("allergic_information_data");
    localStorage.removeItem("family_relation_data");
    localStorage.removeItem("family_disease_data");
    localStorage.removeItem("token");

    navigate("/Login");
  };
  const token = localStorage.getItem("token");
  const headers = {
    Authorization: `Bearer ${token}`, // Add the token to the request headers
  };

  const fetchData = async () => {
    Axios.get(
      `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/Doctors/get_patients_doctor_list?patientsid=${pid}&MDT=PM&user_role=rp`,
      { headers }
    )
      .then((response) => {
        console.log(response.data);
        if (response.data.status == "1") {
          setDoctorList(response.data.data);
        } else if (response.data.status == "401") {
          message.error("Unauthorized access. Logging out.");
          logoutHandler();
        } else {
          message.error("An error occurred. Please try again later.");
        }
      })
      .catch((error) => {
        // console.error('Error fetching doctor details:', error);
        if (error.response && error.response.status == '401') {
          message.error(error.response.data.message);
          logoutHandler();
        } else {
          message.error("An error occurred. Please try again later.");
        }
      });
    // Fetch specialization details
    const specializationResponse = await Axios.get(
      `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/PickList/get_specialiazation?MDT=PM&user_role=rp`
    );

    console.log(specializationResponse.data);

    if (specializationResponse.data.status == '401') {
      message.error("Unauthorized access. Logging out.");
      logoutHandler();
    } else {
      setSpecializationDetails(specializationResponse.data.response || []);  // Ensure an empty array is set if no data
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleAddDoctorDialogClose = () => {
    setAddDoctorDialog(false);
  };

  const addDoctors = (id) => {
    setAddDoctorDialog(true);
    //setUploadedDocId(id);
  };

  const addHandler = (e) => {
    setButtonHide(true);
    let pid = localStorage.getItem("patientid");
    console.log(pid);
    e.preventDefault();

    // Form data creation
    let formdata = new FormData();
    formdata.append("patients_id", pid);
    formdata.append("doctors_name", doctorsName);
    formdata.append("phone_no", phoneNumber);
    formdata.append("location", locationAddress);
    formdata.append("specialization", specialization);
    formdata.append('MDT', 'PM');
    formdata.append('user_role', 'rp');

    // AJAX request to add doctor
    $.ajax({
      type: "POST",
      url: `${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/Doctors/add_patients_doctor`,
      data: formdata,
      processData: false,
      contentType: false,
      headers: headers,
      success(data) {
        console.log("Updated successfully", data);
        if (data.status === 1) {
          message.success("Doctor added successfully");
          setAddDoctorDialog(false);
          setButtonHide(false);
          setPhoneNumber("");
          setSpecialization("");
          setLocationAddress("");
          setDoctorsName("");
          fetchData();
        }
      },
      error(err) {
        setButtonHide(false);
        if (err.status == '401') {
          // Token expired, show message and log out
          message.error(err.responseJSON.message);
          logoutHandler();
        } else {
          console.error("Error occurred:", err.responseText);
          alert(`Error has occurred: ${err.responseText}`);
        }
      },
    });
  };

  return (
    <div className="background-container">
      <Header title={"My Doctor"} />

      {/* Scrollable area for doctor list */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          height: "80vh", // 80% of the screen height
          overflowY: "auto", // Enable scrolling
          padding: "5px 20px", // Add padding for spacing
          boxSizing: "border-box", // Ensure padding doesn't affect width
          scrollbarWidth: 'none', // Hide scrollbar for Firefox
          msOverflowStyle: 'none', // Hide scrollbar for IE/Edge
        }}
      >
        {doctorList.length > 0 ? (
          doctorList.map((result) => (
            <div
              style={{
                marginBottom: 15,
                padding: 15,
                borderRadius: 10,
                backgroundColor: "#fff",
                boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                display: "flex",
                flexDirection: "column",
                fontSize: "12px",
              }}
              key={result.doctorsid}
            >
              {/* First Row */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/* Column 1: Name & Phone */}
                <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
                  <p style={{ fontSize: "14px", fontWeight: "600", textAlign: 'start', color: "black" }}>
                    Name: {result.doctors_name}
                  </p>
                  <p style={{ fontSize: "12px", color: "#555", textAlign: 'start', color: "black" }}>Phone no: {result.phone_no}</p>
                </div>

                {/* Column 2: Image */}
                <div>
                  <img
                    src={user}
                    style={{
                      height: 35,
                      width: 35,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                    alt="Doctor"
                  />
                </div>
              </div>

              {/* Second Row */}
              <div  >
                <p style={{ fontSize: "12px", color: "#777", textAlign: 'start', color: "black" }}>
                  Loaction: {result.location}
                </p>
                <p style={{ fontSize: "12px", color: "#777", textAlign: 'start', color: "black" }}>
                  Specialization: {result.specialization}
                </p>
              </div>
            </div>
          ))
        ) : (
          <p
            style={{
              fontSize: "14px",
              fontWeight: "bold",
              color: "red",
              textAlign: "center",
            }}
          >
            No doctors found
          </p>
        )}
      </div>

      {/* Add Doctor button at the bottom */}
      <div
        style={{
          position: "fixed",
          bottom: "20px",
          left: "0",
          width: "100%",
          padding: "0 20px", // Add margins
          boxSizing: "border-box",
        }}
      >
        <button
          type="button"
          className="btn btn-primary"
          style={{
            fontSize: "16px",
            padding: "15px 25px",
            borderRadius: "8px",
            backgroundColor: "#007bff",
            color: "#fff",
            width: "100%", // Full-width button
          }}
          onClick={addDoctors}
        >
          Add Doctor
        </button>
      </div>

      {/* Dialog for adding doctor */}
      <Dialog
        open={addDoctorDialog}
        onClose={handleAddDoctorDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <div style={{ textAlign: "right" }}>
            <Button style={{ color: "red" }} onClick={handleAddDoctorDialogClose}>
              CLOSE
            </Button>
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <p style={{ fontSize: "12px", fontWeight: "600", textAlign: "left" }}>
              Doctor's Name
            </p>
            <div style={{ width: "250px", textAlign: "left" }}>
              <input
                className="input_style"
                value={doctorsName}
                maxLength={24}
                onChange={(event) => nameChangeHandler(event)}
                type="text"
                required
              />
            </div>
            <p style={{ fontSize: "12px", fontWeight: "600", textAlign: "left" }}>
              Phone Number
            </p>
            <div style={{ width: "250px", textAlign: "left" }}>
              <input
                className="input_style"
                value={phoneNumber}
                maxLength={10}
                onChange={(event) => phoneNumberChangeHandler(event)}
                type="tel"
                required
              />
            </div>
            <p style={{ fontSize: "12px", fontWeight: "600", textAlign: "left" }}>
              Specialization
            </p>
            <div>
              <select
                name="specialization"
                className="input_style"
                value={specialization}
                onChange={(event) => specializationHandeler(event)}
              >
                <option value="">Select</option>
                {specializationDetails.length > 0 ? (
                  specializationDetails.map((val) => {
                    return (
                      <option value={val.name} key={val.name}>
                        {val.name}
                      </option>
                    );
                  })
                ) : (
                  <option value="">No specialization available</option>
                )}
              </select>
            </div>
            <p style={{ fontSize: "12px", fontWeight: "600", textAlign: "left" }}>
              Location
            </p>
            <div style={{ width: "250px", textAlign: "left" }}>
              <input
                className="input_style"
                value={locationAddress}
                maxLength={30}
                onChange={(event) => locationChangeHandler(event)}
                type="text"
                required
              />
            </div>
            <form
              method="post"
              onSubmit={(event) => addHandler(event)}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                width: "100%", // Ensures full width in dialog
              }}
            >
              {buttonHide === false ? (
                <button
                  type="submit"
                  style={{
                    marginTop: 30,
                    padding: "10px 20px",
                    borderRadius: "5px",
                    backgroundColor: "#007bff",
                    color: "#fff",
                    border: "none",
                    cursor: "pointer",
                  }}
                  className="btn btn-auto btn-primary"
                >
                  Add
                </button>
              ) : (
                <p
                  style={{
                    fontSize: "12px",
                    color: "green",
                    fontWeight: "bold",
                    marginTop: 15,
                    textAlign: "center",
                  }}
                >
                  Add...
                </p>
              )}
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};
